import RichText from "@/components/RichText";
import { resolveButtonStyle } from "@/lib/ctaButtonStyle";
import CtaButtonBlocks, { ctaButtonBlocks } from "./CtaButtonBlocks";

// Modèle de bandeau principal « centré ». Aucune image, aucun ornement : le
// titre porte tout. C'est le style qui va aux activités qui n'ont pas de
// visuel à montrer (conseil, service, cabinet) — précisément celles pour
// lesquelles le hero historique, bâti autour d'une illustration et d'un
// formulaire de rappel, sonnait faux.
const DEFAULTS = {
  eyebrow: "",
  headline: "Votre accroche principale",
  subheadline: "",
  cta_primary_label: "Nous contacter",
  cta_primary_url: "/#contact",
  cta_secondary_label: "",
  cta_secondary_url: "",
  variant: "light",
  anchor_id: "",
};

export default function HeroCenteredSection({ props = {}, blocks }) {
  const t = { ...DEFAULTS, ...props };
  const primary = resolveButtonStyle(t, "cta_primary");
  const secondary = resolveButtonStyle(t, "cta_secondary");
  const extraButtons = ctaButtonBlocks(blocks);
  const dark = t.variant === "dark";

  return (
    <section id={t.anchor_id || undefined} className={`${dark ? "bg-ink" : "bg-cream"} scroll-mt-28`}>
      <div className="max-w-[820px] mx-auto px-6 md:px-10 py-16 md:py-24 text-center">
        {t.eyebrow && (
          <RichText
            as="p"
            className="text-[13px] font-semibold tracking-wide text-gold uppercase mb-4"
            html={t.eyebrow}
          />
        )}
        <RichText
          as="h1"
          className={`font-display font-semibold text-[36px] md:text-[52px] leading-[1.05] tracking-[-0.025em] ${dark ? "text-white" : "text-ink"}`}
          html={t.headline}
        />
        {t.subheadline && (
          <RichText
            as="p"
            preserveParagraphs
            className={`text-[17px] leading-relaxed mt-6 mx-auto max-w-xl ${dark ? "text-white/75" : "text-graphite"}`}
            html={t.subheadline}
          />
        )}
        {(t.cta_primary_label || t.cta_secondary_label || extraButtons.length > 0) && (
          <div className="flex flex-wrap items-center justify-center gap-3 mt-9">
            {t.cta_primary_label && (
              <a
                href={t.cta_primary_url || "#"}
                className={`inline-flex items-center gap-2 px-8 py-3.5 text-[14px] font-semibold hover:opacity-90 transition-opacity ${
                  dark ? "bg-white text-ink" : "bg-ink text-white"
                } ${primary.className}`}
                style={primary.style}
                aria-label={!primary.showText ? t.cta_primary_label : undefined}
              >
                {primary.showIcon && primary.Icon && <primary.Icon className="h-4 w-4" />}
                {primary.showText && t.cta_primary_label}
              </a>
            )}
            {t.cta_secondary_label && (
              <a
                href={t.cta_secondary_url || "#"}
                className={`inline-flex items-center gap-2 border-control px-8 py-3.5 text-[14px] font-semibold transition-colors ${
                  dark ? "border-white/25 text-white hover:bg-white/10" : "border-stone text-ink hover:bg-ink/5"
                } ${secondary.className}`}
                style={secondary.style}
                aria-label={!secondary.showText ? t.cta_secondary_label : undefined}
              >
                {secondary.showIcon && secondary.Icon && <secondary.Icon className="h-4 w-4" />}
                {secondary.showText && t.cta_secondary_label}
              </a>
            )}
            <CtaButtonBlocks blocks={extraButtons} tone={dark ? "dark" : "light"} />
          </div>
        )}
      </div>
    </section>
  );
}
